import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { Globals } from '../../../../globals';
import { ARService } from '../../ar.service';
import { dataPatient, enumValidValueItem } from '../../_models/ar.models';
import { ActivatedRoute, Router } from '@angular/router';
import { DataARClaimListModel } from '../../models/data-ar-claim-list';
import { TdoTableSelectionEvent } from '../../../../tdo-controls/common/tdo-table-v2/models/tdo-table-selection.event';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ReportViewerDialogComponent } from '../../../reports/report-viewer-dialog/report-viewer-dialog.component';
import { DataARClaimModel } from '../../../../models/accountsReceivable/data-ar-claim.model';
import { ClaimViewComponent } from '../claim-view/claim-view.component';
import { TdoTableV2Component } from '../../../../tdo-controls/common/tdo-table-v2/tdo-table-v2.component';
import { ClaimStatusEnum } from '../../../../models/enum/claim-status.enum';
import { ValidationLogItem } from '../../models/ValidationLogItem.model';
import { ClaimValidationDetailComponent } from '../claim-validation-detail/claim-validation-detail.component';
import { ClaimMethodEnum } from '../../../../models/enum/notification/claim-method.enum';
import { NotesService } from '../../../../services/notes.service';
import { TdoNoteQueryModel } from '../../../../main-interface/controls/tdo-notes/models/tdo-note-query.model';
import { NoteCategoryEnum } from '../../../../models/enum/note-category.enum';
import { NoteTypeEnum } from '../../../../models/enum/note-type.enum';
import { Subscription } from 'rxjs';
import { ClaimStatusDxDialogComponent } from '../claim-status-dx-dialog/claim-status-dx-dialog.component';
import { UiService } from 'src/app/services/ui.service';

@Component({
    standalone: false,
    selector: 'app-claim-management',
    templateUrl: './claim-management.component.html',
    styleUrls: ['./claim-management.component.css']
})
export class ClaimManagementComponent implements OnInit {
    @ViewChild(TdoTableV2Component) tdoTable: TdoTableV2Component;

    LOCID: number;
    isLoading: boolean = true;
    isSendingClaims: boolean = false;
    isOpeningClaim: boolean = false;
    checkingClaimIds: Set<string> = new Set<string>();
    PatientCaseId: string = '';
    PatientId: string = '';
    dxResponse: any;
    enumClaimStatusFilter: string = null;
    ClaimNumber: number = null;
    selectedClaim: DataARClaimListModel;

    listOfLocations: any[] = [];
    listOfDoctors: any[] = [];

    // Event handlers for cell styling
    onMasterCellPrepared: (e: any) => void;
    onDetailCellPrepared: (e: any) => void;

    // Added for mat-table implementation
    displayedColumns: string[] = ['claimNumber', 'patientDoctor', 'insurance', 'dates', 'location', 'method', 'status', 'actions'];
    currentClaim: DataARClaimListModel = null;
    hoveredClaim: DataARClaimListModel = null;

    dataClaims: DataARClaimListModel[] = [];
    dataClaimsMaster: DataARClaimListModel[] = [];
    dataPatients: dataPatient[] = [];
    claimTypes: enumValidValueItem[] = [];
    claimStatuses: enumValidValueItem[] = [];
    claimMethods: enumValidValueItem[] = [];

    enumClaimStatusCancelled: string = ClaimStatusEnum.Canceled;
    enumClaimStatusPendingReview: string = ClaimStatusEnum.PendingReview;
    enumClaimStatusReadyToSend: string = ClaimStatusEnum.ReviewedReadyToSend;
    enumClaimStatusClosed: string = ClaimStatusEnum.Closed;
    enumClaimStatusSent: string = ClaimStatusEnum.Sent;

    enumClaimCheckStatusIDNotChecked: string = '00000208-1000-0000-0000-000000000001';
    enumClaimCheckStatusIDProblem: string = '00000208-1000-0000-0000-000000000002';
    enumClaimCheckStatusIDPass: string = '00000208-1000-0000-0000-000000000003';

    private sub: Subscription;

    searchPredicate: (data: any, filter: string) => boolean;

    constructor(
        private readonly uiService: UiService,
        private readonly globals: Globals,
        private readonly arService: ARService,
        private readonly router: Router,
        private readonly dialog: MatDialog,
        private readonly notesService: NotesService,
        private readonly route: ActivatedRoute,
        private readonly changeRef: ChangeDetectorRef,
    ) {
        this.searchPredicate = (data: DataARClaimListModel, filter: string) => {
            if ((!data.PatientFirstName ? '' : data.PatientFirstName).toLowerCase().includes(filter)) {
                return true;
            }
            else if ((!data.PatientLastName ? '' : data.PatientLastName).toLowerCase().includes(filter)) {
                return true;
            }
            else if ((!data.DoctorFullName ? '' : data.DoctorFullName).toLowerCase().includes(filter)) {
                return true;
            }
            else if ((!data.PatientInsuranceName ? '' : data.PatientInsuranceName).toLowerCase().includes(filter)) {
                return true;
            }
            else if ((!data.ClaimType ? '' : data.ClaimType).toLowerCase().includes(filter)) {
                return true;
            }
            else if ((!data.ClaimStatus ? '' : data.ClaimStatus).toLowerCase().includes(filter)) {
                return true;
            }
            else if ((!data.TDOClaimNumber ? 0 : data.TDOClaimNumber).toString().includes(filter)) {
                return true;
            }
            else {
                return false;
            }

        };
    }

    // V2
    calculatePatientName(dataRow: any) {
        return dataRow.PatientFirstName + ' ' + dataRow.PatientLastName;
    }


    // V2 end


    resetNotesFilter(objectId: string = '', patientId: string = '') {
        const model = new TdoNoteQueryModel();
        model.parentObjectName = 'dataARClaims';
        model.objectId = objectId;
        model.patientId = patientId || this.globals.currentPatientId;
        model.categoryEnumId = NoteCategoryEnum.Claim;
        model.typeEnumId = NoteTypeEnum.Patient;
        this.notesService.changeNoteQuery(model);
    }

    async ngOnInit() {

        let currentDate: Date = new Date();

        this.LOCID = parseInt(localStorage.getItem('LOCID'));
        this.PatientCaseId = this.globals.currentPatientCaseId;
        this.PatientId = this.globals.currentPatientId;
        this.ClaimNumber = parseInt(localStorage.getItem('TDOClaimNumber'));

        this.resetNotesFilter('');

        const promises: any[] = [
            this.arService.getAllClaims().toPromise(),
            this.arService.getEnumStatusesForClaims().toPromise(),
            this.arService.getEnumMethodsForClaims().toPromise()
        ];

        this.isLoading = true;

        try {
          const results: any[] = await Promise.all(promises);
          this.dataClaimsMaster = results[0];
          this.dataClaims = results[0];
          this.claimStatuses = results[1];
          this.claimMethods = results[2];

          // Custom cell styling for master grid
          this.onMasterCellPrepared = (e: any) => {
              if (e.rowType === 'data' && !e.column.command) {
                  e.cellElement.style.fontSize = '16px';
              }
          }

          // Custom cell styling for detail grid
          this.onDetailCellPrepared = (e: any) => {
              if (e.rowType === 'data' && !e.column.command) {
                  e.cellElement.style.fontSize = '11px';
              }
          }

          currentDate = new Date();
        //   console.log('Claim Management', currentDate.toLocaleString());

        //   console.log('dataClaims', this.dataClaims);

          if (this.ClaimNumber) {
              localStorage.removeItem('TDOClaimNumber');
              this.dataClaims = this.dataClaimsMaster.filter(a => a.TDOClaimNumber === this.ClaimNumber);
          }

          /* const events: TdoTableSelectionEvent = new TdoTableSelectionEvent();
        event.
        events.model = this.selectedClaim;
        events.isSelected = true;
        this.onRowSelected(events);*/
        } catch (e) {
          console.error('Error loading claim management data', e);
        } finally {
          this.isLoading = false;
          this.changeRef.detectChanges();
        }

        currentDate = new Date();

        if (this.ClaimNumber) {
            localStorage.removeItem('TDOClaimNumber');
            this.dataClaims = this.dataClaimsMaster.filter(a => a.TDOClaimNumber === this.ClaimNumber);
        }

        /* const events: TdoTableSelectionEvent = new TdoTableSelectionEvent();
      event.
      events.model = this.selectedClaim;
      events.isSelected = true;
      this.onRowSelected(events);*/
    }

    getPatientsFromPatientIds(patientIds: string[]) {
        return this.arService.getPatientsFromIds(patientIds).toPromise();
    }

    getInitVariables() {
        const promise = new Promise(async (resolve, reject) => {

            const patientCaseId = this.globals.currentPatientSelectedCaseItem.PatientCaseId;

            const promises = [
                this.getAppointmentInformation(patientCaseId),
            ];

            try {
                const results: any[] = await Promise.all(promises);
                const appointment = results[0];
                this.PatientId = appointment.PatientId;
                resolve(true);
            } catch (err) {
                reject(err);
            }

        });
        return promise;
    }

    getAppointmentInformation(PatientCaseId: string) {
        return this.arService.getAppointmentInformation(PatientCaseId).toPromise();
    }

    getAllClaims(): Promise<DataARClaimListModel[]> {
        return this.arService.getAllClaims().toPromise() as Promise<DataARClaimListModel[]>;
    }

    navigateTo(path) {
        this.router.navigate([path]);
    }

    createMessage(message, type) {
        this.uiService.displayMessage(type, message);
    }

    // Handle selection and deselection of rows model data
    onRowSelected(event: TdoTableSelectionEvent) {
        this.resetNotesFilter(event.isSelected ? event.model.ARClaimID : '', event.isSelected ? event.model.PatientId : '');
        const claimModel = this.dataClaims.find(p => p === event.model);
        if (claimModel) {
            claimModel.DATA_SELECTED = event.isSelected;
        }
    }

    convertUTCDateToLocalDateFromString(dateString) {
        if (!dateString) {
            return null;
        }

        const date = new Date(dateString);
        return this.convertUTCDateToLocalDate(date);
    }

    convertUTCDateToLocalDate(date) {
        return new Date(
            Date.UTC(
                date.getFullYear(),
                date.getMonth(),
                date.getDate(),
                date.getHours(),
                date.getMinutes(),
                date.getSeconds()
            )
        );
    }

    showADAFormDialog(item: DataARClaimListModel) {

        const config = new MatDialogConfig();
        config.width = '1300px';
        config.height = '900px';
        config.data = {
            patientId: 'testing',
        };
        config.panelClass = 'dialog';

        const reportViewer = this.dialog.open(ReportViewerDialogComponent, config);
    }

    openClaim(item: DataARClaimListModel) {
        if (this.isOpeningClaim) {
            return;
        }
        this.isOpeningClaim = true;

        const config = new MatDialogConfig();
        config.width = '900px';
        config.height = '700px';
        config.disableClose = true;
        config.data = {
            ARClaimID: item.ARClaimID,
            enumClaimStatusID: item.enumClaimStatusID,
            enumClaimCheckStatusID: item.enumClaimCheckStatusID,
        };
        config.panelClass = 'dialog';

        const reportViewer = this.dialog.open(ClaimViewComponent, config);

        reportViewer.afterClosed().subscribe(result => {
            this.isOpeningClaim = false;
            if (result) {
                this.isLoading = true;
                this.arService.getAllClaims()
                    .subscribe(response => {

                        this.dataClaims = response;
                        this.isLoading = false;

                        // v2 by zoli
                        // this.tdoTable.dataSource = this.dataClaims;
                        // this.tdoTable.updateData();

                    },
                        err => {
                            // show error
                            this.isLoading = false;
                            this.createMessage('Error loading claims', 'Error');
                        });
            }
        }, err => {
            this.isOpeningClaim = false;
            this.createMessage('Error loading claim details', 'Error');
            this.isLoading = false;
        });
    }

    testSend() {
        this.getDXClaimSubmission();
    }

    getDXClaimSubmission() {
        return this.arService.getDXClaimSubmission().toPromise();
    }

    sendClaims() {
        if (this.isSendingClaims) {
            return;
        }
        this.isSendingClaims = true;

        // update status to sending ...
        let count = 0;
        this.dataClaims.forEach(a => {
            // if ready to send, set status to sending
            if (a.enumClaimStatusID === ClaimStatusEnum.ReviewedReadyToSend && a.enumClaimMethodID === ClaimMethodEnum.APIDX) {

                a.enumClaimStatusID = ClaimStatusEnum.Sending;
                a.ClaimStatus = 'Sending...';
                count++;

                // also update master view
                this.dataClaimsMaster.forEach(b => {
                    if (a.ARClaimID === b.ARClaimID) {
                        b.enumClaimStatusID = ClaimStatusEnum.Sending;
                        b.ClaimStatus = 'Sending...';

                        if (b.enumClaimMethodID === ClaimMethodEnum.ADAForm) {
                            b.SentDate = new Date();
                        }
                    }
                });
            }
        });

        // send claims to dental exchange
        this.arService.sendClaimsToDentalExchange()
            .subscribe({
                next: (resp: any) => {
                    this.isLoading = false;
                    this.isSendingClaims = false;

                    // if we get proper response, update statuses
                    if (resp != null && resp.length > 0) {
                        resp.forEach(a => {
                            this.dataClaims.forEach(b => {
                                if (b.ARClaimID === a.ARClaimID) {
                                    b.enumClaimStatusID = a.enumClaimStatusID;
                                }
                            });
                        });
                    }
                    else {
                        // set "sending" claims to error status
                        this.setClaimsToSendingError();
                    }
                },
                error: (err: any) => {
                    this.isSendingClaims = false;
                    // show error
                    // set "sending" claims to error status
                    this.setClaimsToSendingError();
                }
            });
    }

    setClaimsToSendingError() {
        this.dataClaims.forEach(a => {
            // if sending, set status to sending error
            if (a.enumClaimStatusID === ClaimStatusEnum.Sending && a.enumClaimMethodID === ClaimMethodEnum.APIDX) {
                a.enumClaimStatusID = ClaimStatusEnum.SendError;

                // also update master view
                this.dataClaimsMaster.forEach(b => {
                    if (a.ARClaimID === b.ARClaimID) {
                        b.enumClaimStatusID = ClaimStatusEnum.SendError;
                    }
                });
            }
        });
    }

    checkClaim(claim: DataARClaimListModel) {
        if (this.checkingClaimIds.has(claim.ARClaimID)) {
            return;
        }
        const claimMaster = this.dataClaimsMaster.filter(a => a.ARClaimID === claim.ARClaimID);
        this.checkingClaimIds.add(claim.ARClaimID);

        if (claim.enumClaimMethodID && claim.enumClaimMethodID === ClaimMethodEnum.APIDX) {
            this.arService.getDXClaimValidationResult(claim.ARClaimID)
                .subscribe({
                    next: (response: any) => {
                        // read response
                        this.dxResponse = response;
                        this.isLoading = false;
                        this.checkingClaimIds.delete(claim.ARClaimID);

                        if (response.ErrorStatus === 0) {
                            // validation appears to have succeeded
                            this.createMessage('Internal Validation Successful', 'Success');

                            // update enumClaimCheckStatusID status to passed
                            claim.enumClaimCheckStatusID = this.enumClaimCheckStatusIDPass;
                            claimMaster[0].enumClaimCheckStatusID = this.enumClaimCheckStatusIDPass;
                        }
                        else if (response.ErrorStatus === 100) {
                            // internal validation succeeded, but DX validation failed
                            this.createMessage('Internal validation succeeded, but DXC validation failed. Open Claim Details for more information.', 'Warning');

                            // update enumClaimCheckStatusID status to passed
                            claim.enumClaimCheckStatusID = this.enumClaimCheckStatusIDProblem;
                            claimMaster[0].enumClaimCheckStatusID = this.enumClaimCheckStatusIDProblem;
                        }
                        else {
                            // show our claim validation window
                            this.openClaimValidationDetail(response.ValidationLogItems);

                            // update enumClaimCheckStatusID status to problem
                            claim.enumClaimCheckStatusID = this.enumClaimCheckStatusIDProblem;
                            claimMaster[0].enumClaimCheckStatusID = this.enumClaimCheckStatusIDProblem;
                        }

                        // update enumClaimCheckStatus in DB
                        const claimToUpdate = new DataARClaimModel();
                        claimToUpdate.ARClaimID = claim.ARClaimID;
                        claimToUpdate.enumClaimCheckStatusID = claim.enumClaimCheckStatusID;
                        this.arService.saveClaimCheckStatus(claimToUpdate)
                            .subscribe({
                                next: (checkResponse: any) => {
                                    this.isLoading = false;
                                },
                                error: (err: any) => {
                                    // show error
                                    this.createMessage('Error saving claim check status. Please try again.', 'Error');
                                }
                            });

                        // this.closeRef();
                    },
                    error: (err: any) => {
                        // show error
                        console.error('Error checking claim', err);
                        const errorMessage = 'Error checking claim. Please try again. ' + (err.error.ExceptionMessage ?? '');
                        this.createMessage(errorMessage, 'Error');
                        this.checkingClaimIds.delete(claim.ARClaimID);
                    },
                    complete: () => {
                        this.isLoading = false;
                    }
                });
        }
        else {
            // claim to be sent via ada form, don't run dx api
            this.arService.getInternalClaimValidationResult(claim.ARClaimID)
                .subscribe({
                    next: (response: any) => {
                        // read response
                        this.dxResponse = response;
                        this.isLoading = false;
                        this.checkingClaimIds.delete(claim.ARClaimID);

                        if (response.ErrorStatus === 0) {
                            // validation appears to have succeeded
                            this.createMessage('Internal Validation Successful.', 'Success');

                            // update enumClaimCheckStatusID status to passed
                            claim.enumClaimCheckStatusID = this.enumClaimCheckStatusIDPass;
                            claimMaster[0].enumClaimCheckStatusID = this.enumClaimCheckStatusIDPass;
                        }
                        else {
                            // show our claim validation window
                            this.openClaimValidationDetail(response.ValidationLogItems);

                            // update enumClaimCheckStatusID status to problem
                            claim.enumClaimCheckStatusID = this.enumClaimCheckStatusIDProblem;
                            claimMaster[0].enumClaimCheckStatusID = this.enumClaimCheckStatusIDProblem;
                        }

                        // update enumClaimCheckStatus in DB
                        const claimToUpdate = new DataARClaimModel();
                        claimToUpdate.ARClaimID = claim.ARClaimID;
                        claimToUpdate.enumClaimCheckStatusID = claim.enumClaimCheckStatusID;
                        this.arService.saveClaimCheckStatus(claimToUpdate)
                            .subscribe({
                                next: (checkResponse: any) => {
                                    this.isLoading = false;
                                },
                                error: (err: any) => {
                                    // show error
                                    console.error('Error saving claim check status', err);
                                    this.createMessage('Error saving claim check status. Please try again.', 'Error');
                                },
                                complete: () => {
                                    this.isLoading = false;
                                }
                            });
                    },
                    error: (err: any) => {
                        // show error
                        console.error('Error checking claim', err);
                        const errorMessage = 'Error checking claim. Please try again. ' + (err.error.ExceptionMessage ?? '');
                        this.createMessage(errorMessage, 'Error');
                        this.checkingClaimIds.delete(claim.ARClaimID);
                    },
                    complete: () => {
                        this.isLoading = false;
                    }
                });
        }
    }

    openClaimValidationDetail(items: ValidationLogItem[]) {

        const config = new MatDialogConfig();
        config.width = '900px';
        config.height = '675px';
        config.data = {
            ValidationLogItems: items,
        };
        config.panelClass = 'dialog';

        this.dialog.open(ClaimValidationDetailComponent, config);

    }

    saveClaimMethod(ARClaimID: string, event) {
        // save claim method
        const claim = this.dataClaims.filter(a => a.ARClaimID === ARClaimID);
        const claimMaster = this.dataClaimsMaster.filter(a => a.ARClaimID === ARClaimID);

        if (claim.length === 1) {
            claim[0].enumClaimMethodID = event.value;
            claimMaster[0].enumClaimMethodID = event.value;

            this.arService.saveClaimMethod(claim[0])
                .subscribe(response => {
                    if (response) {
                        // response is good
                    }
                },
                    err => {
                        // show error
                        this.createMessage('Problem saving claim method.', 'Error');
                    });
        }
        else {
            // show error
            this.createMessage('Problem saving claim method.', 'Error');
        }
    }

    saveClaimStatus(ARClaimID: string, event) {
        // save claim status
        const claim = this.dataClaims.filter(a => a.ARClaimID === ARClaimID);
        const claimMaster = this.dataClaimsMaster.filter(a => a.ARClaimID === ARClaimID);

        if (claim.length === 1) {
            claim[0].enumClaimStatusID = event.value;
            claimMaster[0].enumClaimStatusID = event.value;

            if (event.value === this.enumClaimStatusClosed) {
                claim[0].ClosedDate = new Date();
                claimMaster[0].ClosedDate = new Date();
            }

            this.arService.saveClaimStatus(claim[0])
                .subscribe({
                    next: (response: any) => {
                        if (response) {
                            // response is good
                        }
                    },
                    error: (err: any) => {
                        // show error
                        this.createMessage('Problem saving claim status.', 'Error');
                    }
                });
        }
        else {
            // show error
            this.createMessage('Problem saving claim status.', 'Error');
        }
    }

    filterByClaimStatus(event) {
        if (event.value) {
            this.dataClaims = this.dataClaimsMaster.filter(a => a.enumClaimStatusID === event.value);
            this.tdoTable.dataSource = this.dataClaims;
            this.tdoTable.updateData();
        }
    }

    openDXStatus(ARClaimID: string) {
        this.launchClaimStatusResponseViewer(ARClaimID);
    }

    launchClaimStatusResponseViewer(ARClaimId: string) {

        const config = new MatDialogConfig();
        config.width = '617px';
        config.height = '745px';
        config.data = {
            ARClaimID: ARClaimId,
        };
        config.panelClass = 'dialog';

        const rtbViewer = this.dialog.open(ClaimStatusDxDialogComponent, config);
    }

    // Added methods for mat-table implementation
    selectClaim(claim: DataARClaimListModel) {
        this.currentClaim = claim;

        // Create a selection event to maintain compatibility with existing code
        const event: TdoTableSelectionEvent = new TdoTableSelectionEvent();
        event.model = claim;
        event.isSelected = true;
        this.onRowSelected(event);
    }

    // Action button handlers
    actionOne(claim: DataARClaimListModel, event: MouseEvent) {
        // Info button
        event.stopPropagation(); // Prevent row selection
        this.openDXStatus(claim.ARClaimID);
    }

    actionTwo(claim: DataARClaimListModel, event: MouseEvent) {
        // Document button
        event.stopPropagation(); // Prevent row selection
        this.openClaim(claim);
    }

    actionThree(claim: DataARClaimListModel, event: MouseEvent) {
        // Check button
        event.stopPropagation(); // Prevent row selection
        this.checkClaim(claim);
    }

    protected readonly ClaimMethodEnum = ClaimMethodEnum;
}
